import { Component, Input, Output, EventEmitter } from '@angular/core';


@Component({
  moduleId: module.id,
  selector: 'delete-checkbox, [deleteCheckbox]',
  templateUrl: 'delete-checkbox.component.html',
  styleUrls: ['delete-checkbox.component.scss'],
})
export class DeleteCheckboxComponent {
  @Input() name: string = '';
  @Input() model: boolean = false;
  @Output() modelChange: EventEmitter<Boolean> = new EventEmitter();

}
